module.exports = __webpack_public_path__ + "static/media/icon-whatsapp.be10a905.svg";